import { HeadSad } from "./HeadSad";
export default HeadSad;
